import { create } from 'zustand';
import i18n from 'i18n';
import { ApiUtils, GetMessagesThreadsResponse, MessagesApi, PostMessageRequest } from '@shared/api';

interface UsePostMessagesStore {
  loading: boolean;
  data: GetMessagesThreadsResponse | null;
  error?: string | null;
  post: (request: PostMessageRequest) => Promise<{
    loading: boolean;
    data: GetMessagesThreadsResponse | null;
    error?: string | null;
  }>;
  clear: () => void;
}

export const usePostMessagesStore = create<UsePostMessagesStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  post: async (request: PostMessageRequest) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await MessagesApi.postMessage(request);
      set({ loading: false, data: result ?? null });
      return { loading: false, data: result ?? null };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
